<template>
  <div>
    <div class="vld-parent">
        <loading :active.sync="showloading"
        :is-full-page="true"></loading>
      <form-wizard
        v-if="!iscompleto"
        @on-complete="onComplete"
        title
        subtitle
        shape="circle"
        color="#e67e22"
        error-color="#ff4949"
        :start-index="0"
      >
        <tab-content title="Responsável" icon="icon ion-md-contact" :before-change="validaResp">
          <b-form ref="regraFormResp">
             <b-form-input v-model.lazy="formResp.id" style="display: none"></b-form-input>
            <b-row>
              <b-col md="12" class="mt-1 mb-1">
                <label for="formRespCpf">CPF Responsável</label>
                <b-form-input v-mask="'###.###.###-##'" class="col-sm-12" v-model.lazy="$v.formResp.cpf.$model" :state="validateStateResp('formResp', 'cpf')" id="formRespCpf" name="formRespNome" @change="campoCpfAlterado" @blur="getCadastro"></b-form-input>
                <b-form-invalid-feedback id="formRespCpf" >
                  {{ $v.formResp.cpf.$params.errors[0] }}
                </b-form-invalid-feedback>
              </b-col>

              <b-col md="12" class="mt-1 mb-1">
                <label for="formRespNome">Nome Responsável</label>
                <b-form-input class="text-uppercase" v-model="$v.formResp.nome.$model" :state="validateStateResp('formResp', 'nome')" id="formRespNome" name="formRespNome"></b-form-input>
                <b-form-invalid-feedback id="formRespNome" >
                  {{ $v.formResp.nome.$params.errors[0] }}
                </b-form-invalid-feedback>
              </b-col>


              <b-col md="6" class="mt-1 mb-1">
                <label for="formRespSexo">Sexo Responsável</label>
                <b-form-radio-group
                  id="formRespSexo"
                  v-model="$v.formResp.sexo.$model"
                  :options="opcoessexo"
                  :state="validateStateResp('formResp', 'sexo')"
                  name="formRespSexo"
                >
                  <b-form-invalid-feedback id="formRespSexo" :state="false" >
                    {{ $v.formResp.sexo.$params.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-radio-group>
              </b-col>

              <b-col md="6" class="mt-1 mb-1">
                <label for="formRespParentesco">Parentesco</label>
                <b-form-select id="formRespParentesco" v-model="$v.formResp.parentesco.$model" :state="validateStateResp('formResp', 'parentesco')" :options="parentesco"></b-form-select>
                <b-form-invalid-feedback id="formRespParentesco">
                  {{ $v.formResp.parentesco.$params.errors ? $v.formResp.parentesco.$params.errors.length ? $v.formResp.parentesco.$params.errors[0] : null : null }}
                </b-form-invalid-feedback>
              </b-col>
            </b-row>
          </b-form>
        </tab-content>

        <tab-content title="Bailarina(o)" icon="icon ion-md-body" :before-change="validaAluno"> <!-- class="demo-form-inline" -->
          <b-form ref="regraFormAluno">

            <b-row>
              <b-col md="12" class="mt-1 mb-1">
                <label for="formAlunoNome">Nome Bailarina(o)</label>
                <b-form-input class="text-uppercase" v-model="$v.formAluno.nome.$model" :state="validateStateResp('formAluno', 'nome')" id="formAlunoNome" name="formAlunoNome"></b-form-input>
                <b-form-invalid-feedback id="formAlunoNome" >
                  {{ $v.formAluno.nome.$params.errors[0] }}
                </b-form-invalid-feedback>
              </b-col>

              <b-col md="6" class="mt-1 mb-1">
                <label for="formAlunoDataNascto">Data Nascimento</label>
                <!--<b-form-input type="date" v-model="$v.formAluno.datanascto.$model" :state="validateStateResp('formAluno', 'datanascto')" id="formAlunoDataNascto" name="formAlunoDataNascto"></b-form-input> -->
                <b-form-input v-mask="'##/##/####'" v-model="$v.formAluno.datanascto.$model" :state="validateStateResp('formAluno', 'datanascto')" id="formAlunoDataNascto" name="formAlunoDataNascto"></b-form-input>
                <b-form-invalid-feedback id="formAlunoDataNascto" >
                  {{ $v.formAluno.datanascto.$params.errors ? $v.formAluno.datanascto.$params.errors.length ? $v.formAluno.datanascto.$params.errors[0] : null : null }}
                </b-form-invalid-feedback>
              </b-col>

              <b-col md="6" class="mt-1 mb-1">
                <label for="formAlunoSexo">Sexo Bailarina(o)</label>
                <b-form-radio-group
                  id="formAlunoSexo"
                  v-model="$v.formAluno.sexo.$model"
                  :options="opcoessexo"
                  :state="validateStateResp('formAluno', 'sexo')"
                  name="formAlunoSexo"
                >
                  <b-form-invalid-feedback id="formAlunoSexo" :state="false" >
                    {{ $v.formAluno.sexo.$params.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-radio-group>
              </b-col>

              <b-col md="6" class="mt-1 mb-1">
                <label for="formAlunoEscola">Escola</label>
                <b-form-select id="formAlunoEscola" v-model="$v.formAluno.parceiro_id.$model" :state="validateStateResp('formAluno', 'parceiro_id')" :options="escolas" @change="filtraNivelEscolar()"></b-form-select>
                <b-form-invalid-feedback id="formAlunoEscola">
                  {{ $v.formAluno.parceiro_id.$params.errors ? $v.formAluno.parceiro_id.$params.errors.length ? $v.formAluno.parceiro_id.$params.errors[0] : null : null }}
                </b-form-invalid-feedback>
              </b-col>

              <b-col md="6" class="mt-1 mb-1">
                <label for="formAlunoTurma">Turma</label>
                <b-form-select id="formAlunoTurma" v-model="$v.formAluno.nivelescolar_id.$model" :state="validateStateResp('formAluno', 'nivelescolar_id')" :options="nivelescolar" @blur="filtraNivelEscolar"></b-form-select>
                <b-form-invalid-feedback id="formAlunoTurma">
                  {{ $v.formAluno.nivelescolar_id.$params.errors ? $v.formAluno.nivelescolar_id.$params.errors.length ? $v.formAluno.nivelescolar_id.$params.errors[0] : null : null }}
                </b-form-invalid-feedback>
              </b-col>

            </b-row>
            <b-row>
              <b-col md="12" class="mt-3 mb-1">
                <label for="formAlunoTurma">
                  Queremos conhecer melhor sua bailarina(o)! <br>
Conte pra gente se há alguma alergia, restrição alimentar ou algo sobre o desenvolvimento motor e/ou cognitivo que seja importante saber.
                </label>
                <b-form-textarea class="text-uppercase" v-model="$v.formAluno.observacoes.$model" :state="validateStateResp('formAluno', 'observacoes')" id="formAlunoObservacoes" name="formAlunoObservacoes" no-resize rows="4"></b-form-textarea>
                <b-form-invalid-feedback id="formAlunoObservacoes" >
                  {{ $v.formAluno.observacoes.$params.errors[0] }}
                </b-form-invalid-feedback>
              </b-col>
            </b-row>
          </b-form>

        </tab-content>

        <tab-content title="Endereço" icon="icon ion-md-home" :before-change="validaEndereco">
          <b-form ref="regraFormEndereco">

            <b-row>
              <b-col md="12" class="mt-1 mb-1">
                <label for="formAlunoCep">Cep</label>
                <b-form-input v-mask="'#####-###'" v-model="$v.formEndereco.cep.$model" :state="validateStateResp('formEndereco', 'cep')" id="formAlunoCep" name="formAlunoCep" v-on:blur="buscacep" v-on:change="cepAlterado"></b-form-input>
                <b-form-invalid-feedback id="formAlunoCep" >
                  {{ $v.formEndereco.cep.$params.errors[0] }}
                </b-form-invalid-feedback>
              </b-col>

              <b-col md="12" class="mt-1 mb-1">
                <label for="formEnderecoLogradouro">Logradouro</label>
                <b-form-input class="text-uppercase" type="text" v-model="$v.formEndereco.logradouro.$model" :state="validateStateResp('formEndereco', 'logradouro')" id="formEnderecoLogradouro" name="formEnderecoLogradouro"></b-form-input>
                <b-form-invalid-feedback id="formEnderecoLogradouro" >
                  {{ $v.formEndereco.logradouro.$params.errors ? $v.formEndereco.logradouro.$params.errors.length ? $v.formEndereco.logradouro.$params.errors[0] : null : null }}
                </b-form-invalid-feedback>
              </b-col>

              <b-col md="6" class="mt-1 mb-1">
                <label for="formEnderecoComplemento">Complemento</label>
                <b-form-input class="text-uppercase" type="text" v-model="$v.formEndereco.complemento.$model" :state="validateStateResp('formEndereco', 'complemento')" id="formEnderecoComplemento" name="formEnderecoComplemento"></b-form-input>
                <b-form-invalid-feedback id="formEnderecoComplemento" >
                  {{ $v.formEndereco.complemento.$params.errors ? $v.formEndereco.complemento.$params.errors.length ? $v.formEndereco.complemento.$params.errors[0] : null : null }}
                </b-form-invalid-feedback>
              </b-col>

              <b-col md="6" class="mt-1 mb-1">
                <label for="formEnderecoBairro">Bairro</label>
                <b-form-input class="text-uppercase" type="text" v-model="$v.formEndereco.bairro.$model" :state="validateStateResp('formEndereco', 'bairro')" id="formEnderecoBairro" name="formEnderecoBairro"></b-form-input>
                <b-form-invalid-feedback id="formEnderecoBairro" >
                  {{ $v.formEndereco.bairro.$params.errors ? $v.formEndereco.bairro.$params.errors.length ? $v.formEndereco.bairro.$params.errors[0] : null : null }}
                </b-form-invalid-feedback>
              </b-col>

              <b-col md="6" class="mt-1 mb-1">
                <label for="formEnderecoCidade">Cidade</label>
                <b-form-select id="formEnderecoCidade" v-model="$v.formEndereco.cidade.$model" :state="validateStateResp('formEndereco', 'cidade')" :options="cidades"></b-form-select>
                <b-form-invalid-feedback id="formEnderecoCidade">
                  {{ $v.formEndereco.cidade.$params.errors ? $v.formEndereco.cidade.$params.errors.length ? $v.formEndereco.cidade.$params.errors[0] : null : null }}
                </b-form-invalid-feedback>
              </b-col>
            </b-row>
          </b-form>

        </tab-content>

        <tab-content title="Contato" icon="icon ion-logo-whatsapp" :before-change="validaContato">

          <b-form ref="regraFormContato">

            <b-row>
              <b-col md="12" class="mt-1 mb-1">
                <label for="formContatoFoneFixo">Fixo</label>
                <b-form-input v-mask="'(##) ####-####'" v-model="$v.formContato.fonefixo.$model" :state="validateStateResp('formContato', 'fonefixo')" id="formContatoFoneFixo" name="formContatoFoneFixo"></b-form-input>
                <b-form-invalid-feedback id="formContatoFoneFixo" >
                  {{ $v.formContato.fonefixo.$params.errors[0] }}
                </b-form-invalid-feedback>
              </b-col>

              <b-col md="12" class="mt-1 mb-1">
                <label for="formContatoFoneCelular">Celular</label>
                <b-form-input type="text" v-mask="'(##) #####-####'" v-model="$v.formContato.fonecelular.$model" :state="validateStateResp('formContato', 'fonecelular')" id="formContatoFoneCelular" name="formContatoFoneCelular"></b-form-input>
                <b-form-invalid-feedback id="formContatoFoneCelular" >
                  {{ $v.formContato.fonecelular.$params.errors ? $v.formContato.fonecelular.$params.errors.length ? $v.formContato.fonecelular.$params.errors[0] : null : null }}
                </b-form-invalid-feedback>
              </b-col>

              <b-col md="6" class="mt-1 mb-1">
                <label for="formContatoEmail">E-mail</label>
                <b-form-input class="text-lowercase" type="email" v-model="$v.formContato.email.$model" :state="validateStateResp('formContato', 'email')" id="formContatoEmail" name="formContatoEmail"></b-form-input>
                <b-form-invalid-feedback id="formContatoEmail" >
                  {{ $v.formContato.email.$params.errors ? $v.formContato.email.$params.errors.length ? $v.formContato.email.$params.errors[0] : null : null }}
                </b-form-invalid-feedback>
              </b-col>

            </b-row>
          </b-form>

        </tab-content>

        <el-button type="warning" slot="prev">Voltar</el-button>
        <el-button type="warning" slot="next">Próximo</el-button>
        <el-button type="warning" slot="finish">Enviar</el-button>
      </form-wizard>


      <div v-else class="jumbotron text-center">
        <h4 class="display-5">Pré Matrícula concluída!</h4>
        <p class="lead">
          <hr>
          A pré-matrícula não garante vaga nas aulas de balé, pois precisamos de um número mínimo de alunas e as vagas são limitadas.
          <hr>
          Em breve entraremos em contato para confirmação de matrícula e para mais informações.
          <hr>
          Agradecemos por confiar em nosso trabalho.
        </p>
        <hr>
        <p class="lead">
          <b-button size="lg" variant="primary" @click="sair">Fechar</b-button>
          <!--<a class="btn btn-primary btn-sm" role="button" >Voltar para o site</a>-->
        </p>
      </div>


    </div>
    <b-modal id="msg_alerta" title="Atenção" v-model="modalShow" centered :no-close-on-backdrop="true" :no-close-on-esc="true" hide-footer :hide-header-close="true">
      <b-card
        border-variant="warning"
        header-bg-variant="transparent"
        align="center"
      >
        <b-card-text><h4>Verifique todos os dados carregados.</h4></b-card-text>
        <b-button variant="primary" v-show="buttonCloseWarning" @click="modalShow = !modalShow">Fechar</b-button>
      </b-card>

    </b-modal>
  </div>
</template>
<script>

import {required, email, minLength, numeric} from 'vuelidate/lib/validators'
import { VueTelInput } from "vue-tel-input";
import {TheMask} from 'vue-the-mask';
import {mask} from 'vue-the-mask'
import { FormWizard, TabContent } from "vue-form-wizard";
import { validate as validarCPF } from 'gerador-validador-cpf'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import "vue-form-wizard/dist/vue-form-wizard.min.css";
//import crypto from 'crypto'
//import bcrypt from 'bcryptjs';

const validaCpf = (cpf) => {
  if (cpf.length == 14) {
    if (validarCPF(cpf)) { return true}
    return false
  }
};


export default {
  name: "Cadastro",
  components: {
    VueTelInput,
    FormWizard,
    TabContent,
    TheMask,
    Loading
  },
  data() {
    return {
      modalShow: false,
      cpfalterado: false,
      dadoscarregados: null,
      buttonCloseWarning: false,
      errosStr: '',
      iscompleto: false,
      showloading: false,
      cepalterado: false,
      parceiros: [],
      nivelescolar: [],
      opcoessexo: [
        {text: 'Masculino', value: 'M'},
        {text: 'Feminino', value: 'F'},
      ],
      parentesco: [
        { value: "1", text: "Pai/Mãe" },
        { value: "2", text: "Avô/Avó" },
        { value: "3", text: "Padastro/Madastra" },
        { value: "4", text: "Tio/Tia" },
        { value: "5", text: "Irmão/Irmã" },
        { value: "6", text: "Outro" },
      ],
      escolas: [
        /*{ value: "1", text: "Colégio Santa Cruz" },
        { value: "2", text: "Colégio Integrado" },
        { value: "3", text: "Colégio Alfa" },
        { value: "4", text: "Colégio Conexão" },
        { value: "5", text: "Colégio Caic" }*/
      ],
      cidades: [
        { value: "1", text: "Campo Mourão" },
      ],
      label: {datanascto: 'Data de Nascimento',
              nome: 'Nome',
              cpf: 'CPF',
              sexo: 'Sexo',
              parentesco: 'Parentesco',
              parceiro_id: 'Escola',
              cep: 'Cep',
              logradouro: 'Logradouro',
              bairro: 'Bairro',
              cidade: 'Cidade',
              fonefixo: 'Telefone Fixo',
              fonecelular: 'Telefone Celular',
              email: 'E-mail'},
      value: "",
      formResp: { id: "", nome: "", cpf: "", sexo: "", parentesco: "" },
      formAluno: { nome: "", datanascto: "", sexo: "", parceiro_id: "", nivelescolar_id: "", observacoes: "" },
      formEndereco: { cep: "", logradouro: "", bairro: "", complemento: "", cidade: "" },
      formContato: { fonefixo: "", fonecelular: "", email: "" }
    };
  },
  validations: {
    formResp: {
      nome: {required, minLength: minLength(6), errors: [] },
      cpf: {required, minLength: minLength(14), validaCpf, errors: []},
      sexo: {required, errors: []},
      parentesco: {required, errors: []}
    },
    formAluno: {
      nome: {required, minLength: minLength(6), errors: [] },
      sexo: {required, errors: []},
      datanascto: {required, errors: []},
      parceiro_id: {required, errors: []},
      nivelescolar_id: {required, errors: []},
      observacoes: {errors: []}
    },
    formEndereco: {
      cep: {required, minLength: minLength(9), errors: [] },
      logradouro: {required, minLength: minLength(5),errors: []},
      bairro: {required, minLength: minLength(3),errors: []},
      cidade: {required, errors: []},
      complemento: {errors: []}
    },
    formContato: {
      fonefixo: {minLength: minLength(14), errors: [] },
      fonecelular: {required, minLength: minLength(15), errors: []},
      email: {required, email, errors: []},
    }
  },
  created () {
    this.buscaParceiros()
    this.testecrypto()
  },
  methods: {
    sair() {
      this.$root.$emit('bv::hide::modal', 'modal-1')
    },
    filtraNivelEscolar () {
      if (this.formAluno.parceiro_id > 0) {
        this.buscaNivelEscolar()
      }
    },
    buscaParceiros () {
      this.showloading = true
      setTimeout(() => {
        this.$http.get(this.urlAPI + 'parceiro/full', {
          //'headers': {'authorization': 'Bearer ' + this.$store.getters.getToken}
        })
        .then(response => {
          if (response.data.status) {
            this.escolas = []
            let item = {}
            this.parceiros = response.data.parceiros
            this.parceiros.forEach((value, index) => {
              item = { value: value.id, text: value.pessoa.nome }
              this.escolas.push(item)
            });
          }
        })
        .catch(e => {
          alert('Erro! Tente novamente mais tarde...')
        })
        .finally(() => this.showloading = false)
      }, 2000)
    },
    buscaNivelEscolar () {
      if (!this.formAluno.parceiro_id && !(this.formAluno.parceiro_id > 0)) return
      this.showloading = true
      setTimeout(() => {
        this.$http.get(this.urlAPI + 'nivelescolars/dropdown/' + this.formAluno.parceiro_id, {
          //'headers': {'authorization': 'Bearer ' + this.$store.getters.getToken}
        })
        .then(response => {
          if (response.data.status) {
            let niveis = response.data.nivelescolars
            this.nivelescolar = []
            let item = {}
            niveis.forEach((value, index) => {
              if (value.isViewPortal) {
                item = { value: value.id, text: value.descricao }
                this.nivelescolar.push(item)
              }
            });
          }
        })
        .catch(e => {
          alert('Erro! Tente novamente mais tarde...')
        })
        .finally(() => this.showloading = false)
      }, 2000)
    },
    cepAlterado () {
      this.cepalterado = true
    },
    buscacep () {

      if (!this.cepalterado || !this.formEndereco.cep) return
      this.showloading = true
      setTimeout(() => {
        Promise.all([this.getViaCep(this.formEndereco.cep)])
        .then(response => {
          response = response[0];
          if (response.data) {
            if (response.data.erro) {
              this.formEndereco.logradouro = null
              this.formEndereco.bairro = null
              return
            }
            this.formEndereco.bairro = response.data.bairro.toUpperCase()
            this.formEndereco.logradouro = response.data.logradouro.toUpperCase()
          }
        })
        .catch(error => {
          console.log(error)
          alert('Erro! Tente novamente mais tarde...')
        })
        .finally(() => {
          this.showloading = false
          this.cepalterado = false
        });
      }, 2000)
    },
    async getViaCep (cep) {
      let response = await this.$http.get('https://viacep.com.br/ws/'+this.soNumeros(cep)+'/json')
      return response
    },
    campoCpfAlterado() {
      this.cpfalterado = true
    },
    async getCadastro (value) {
      if (!this.cpfalterado) return
      this.cpfalterado = false
      let cpfcnpj = value.target.value.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g,"")
      this.showloading = true
      this.dadoscarregados = {}
      try {
        let response = await this.$http.get(this.urlAPI + `prematricula/${cpfcnpj}`)
        this.dadoscarregados = response.data ? response.data.data ? response.data.data : {} : {}
        if (this.dadoscarregados.nomeresp) {
          this.distribuirDadosCarregados()
          this.mostrarAlertaDados()
          this.modalShow = true
        }

      } catch (e) {
        console.log('Erro ao buscar cadastro');
      } finally {
        this.showloading = false
      }
    },
    mostrarAlertaDados() {
      this.buttonCloseWarning = false
      setTimeout(() => {
        this.buttonCloseWarning = true
      }, 3000);
    },
    distribuirDadosCarregados() {
      this.formResp.id = this.dadoscarregados.id
      this.formResp.nome = this.dadoscarregados.nomeresp
      this.formResp.sexo = this.dadoscarregados.sexoresp
      this.formResp.parentesco = this.dadoscarregados.tipoparentesco

      /*this.formAluno.nome = this.dadoscarregados.nomealuno
      this.formAluno.datanascto = this.dadoscarregados.datanasctoaluno
      this.formAluno.sexo = this.dadoscarregados.sexoaluno*/

      this.formEndereco.cep = this.dadoscarregados.cep
      this.formEndereco.logradouro = this.dadoscarregados.endereco
      this.formEndereco.bairro = this.dadoscarregados.bairro
      this.formEndereco.complemento = this.dadoscarregados.complemento
      this.formEndereco.cidade = this.dadoscarregados.cidade_id

      this.formContato.fonefixo = this.dadoscarregados.fonefixo
      this.formContato.fonecelular = this.dadoscarregados.fonecelular
      this.formContato.email = this.dadoscarregados.email

    },
    validaResp () {
      return new Promise((resolve, reject) => {
        resolve(this.validaFormResponsavel());
      });
    },
    validaAluno () {
      return new Promise((resolve, reject) => {
        resolve(this.validaFormAluno());
      });
    },
    validaEndereco () {
      return new Promise((resolve, reject) => {
        resolve(this.validaFormEndereco());
      });
    },
    validaContato () {
      return new Promise((resolve, reject) => {
        resolve(this.validaFormContato());
      });
    },
    validaFormResponsavel() {
      this.$v.formResp.$touch();
      if (this.$v.formResp.$anyError) {
        return;
      }
      return !this.$v.formResp.$invalid
    },
    validaFormAluno() {
      this.$v.formAluno.$touch();
      if (this.$v.formAluno.$anyError) {
        return;
      }
      return !this.$v.formAluno.$invalid
    },
    validaFormEndereco() {
      this.$v.formEndereco.$touch();
      if (this.$v.formEndereco.$anyError) {
        return;
      }
      return !this.$v.formEndereco.$invalid
    },
    validaFormContato() {
      this.$v.formContato.$touch();
      if (this.$v.formContato.$anyError) {
        return;
      }
      return !this.$v.formContato.$invalid
    },
    onComplete () {
      let send = {}
      var now = new Date;
      var anoatual = now.getFullYear(); // returns -100
      send = {
        //'id': null,
        'nomeresp': this.formResp.nome,
        'cpfcnpjresp': this.soNumeros(this.formResp.cpf),
        'sexoresp': this.formResp.sexo,
        'tipoparentesco': this.formResp.parentesco,
        'nomealuno': this.formAluno.nome,
        'datanasctoaluno': this.parseStrToDate(this.formAluno.datanascto),
        'sexoaluno': this.formAluno.sexo,
        'cidade_id': this.formAluno.parceiro_id,
        'nivelescolar_id': this.formAluno.nivelescolar_id,
        'obs_aluno': this.formAluno.observacoes,
        'cidade_id': this.formEndereco.cidade,
        'endereco': this.formEndereco.logradouro,
        'bairro': this.formEndereco.bairro,
        'cep': this.soNumeros(this.formEndereco.cep),
        'complemento': this.formEndereco.complemento,
        'fonefixo': this.soNumeros(this.formContato.fonefixo),
        'fonecelular': this.soNumeros(this.formContato.fonecelular),
        'email': this.formContato.email,
        'anocadastro': anoatual
      }
      this.errosStr = ''
      this.showloading = true;
      this.$http.post(this.urlAPI + 'prematricula',
        send,
      )
      .then(response => {
        if (response.data.status) {
          this.$toaster.success('Pré-Matrícula efetuada com sucesso!', {timeout: 5000});
          this.iscompleto = true
        } else if (response.data.status === false && response.data.validacao) {
          this.$toaster.error('Ops, um erro ocorreu!', {timeout: 5000})
          console.log(response.data.erros)
          let errosStr = ''
          let obj = response.data.erros
          if (Object.keys(obj).length) {
            Object.keys(obj).forEach(function (item) {
              errosStr += obj[item] + ', '
            })
            this.errosStr = errosStr
          }
        }
      })
      .catch(e => {
        console.log('Pessou pelo catch:' + e)
        alert('Erro! Tente novamente mais tarde...')
      })
      .finally(() => {
        this.showloading = false
      })
    },
    validateStateResp(form, name) {
      return this.validacaoSimples(form, name)
    },
    soNumeros(numeros) {
      if (!numeros) return numeros
      if (numeros.length > 0) {
        return numeros.replace(/\D/g,"")
      }
      return numeros
    },
    parseStrToDate (texto) {
      if (texto.length > 0) {
        var datajv = this.moment(texto, "DD/MM/YYYY");
        return this.moment(datajv).format("YYYY-MM-DD");
      }
      return texto
    },
    validacaoSimples (form, name) {
      const nome = this.$v[form][name]
      this.$v[form][name].$params.errors = []
      if (!nome.$dirty) { return null }
      if (nome.hasOwnProperty("required") && !nome.required) {
        let label = this.label[name]
        this.$v[form][name].$params.errors.push('Campo '+label+' é Obrigatório')
        return false
      }
      if (nome.hasOwnProperty("minLength") && !nome.minLength) {
        this.$v[form][name].$params.errors.push('Informe no mínimo '+nome.$params.minLength.min+ ' caracteres')
        return false
      }
      if (nome.hasOwnProperty("email") && !nome.email) {
        let label = this.label[name]
        this.$v[form][name].$params.errors.push('Insira um e-mail válido')
        return false
      }
      if (nome.hasOwnProperty("validaCpf") && !nome.validaCpf) {
        let label = this.label[name]
        this.$v[form][name].$params.errors.push('Insira CPF válido')
        return false
      }
      return true
    },
    
    testecrypto2 () {
      /*bcrypt.hash('base64:AJuL7oGh6BVHdDYh6lOIVGFkH/kd67qdDsU8d8wp91o=', 10, (err, hash) => {
        if (err) throw err
        console.log(hash);
      });*/

    },

    testecrypto () {
      // generate 16 bytes of random data
      //const iv = crypto.randomBytes(16).toString("hex").slice(0, 16);

      // our secret message
      //const message = "Hello There, I should be a secret";

      // secret key
      //const key = "12345678123456781234567812345678";

      // make the encrypter function
      //const encrypter = crypto.createCipheriv("aes-256-cbc", key, iv);

      //console.log('cript', encrypter);

      
      //const ENC_KEY = "bf3c199c2470cb477d907b1e0917c17b"; // set random encryption key
      //const ENC_KEY = "AJuL7oGh6BVHdDYh6lOIVGFkH/kd67qdDsU8d8wp91o="; // set random encryption key
      //const IV = "5183666c72eec9e4"; // set random initialisation vector
      const IV = ""

      //let cipher = crypto.createCipheriv('aes-256-cbc', ENC_KEY, IV);
      //let encrypted = cipher.update(val, 'utf8', 'base64');
      //encrypted += cipher.final('base64');
      //console.log(encrypted);

    }

  },
  directives: {mask}
};
</script>

<style>
.vue-form-wizard {
  min-height: 450px;
}

#msg_alerta .modal-header {
  display: none;
}

.vue-form-wizard .wizard-header {
  display: none !important;
}

.vue-form-wizard.md .wizard-icon-circle {
  color: #e67e22 !important;
}

.vue-form-wizard .stepTitle {
  color: #e67e22 !important;
}

.vue-form-wizard button {
  min-width: 90px !important;
  max-width: 120px !important;
}

.vue-form-wizard .wizard-tab-content {
  min-height: 20px;
  padding: 20px 20px 10px;
}

.vue-form-wizard.md .wizard-navigation .wizard-progress-with-circle {
  position: relative;
  top: 36px;
  height: 4px;
}

.vue-form-wizard.md .wizard-icon-circle {
  max-width: 60px;
  max-height: 60px;
  font-size: 30px;
}


.vue-form-wizard .el-form-item__label {
  padding: 0;
  margin: 0;
}

.vue-form-wizard .stepTitle {
  font-size: 14px;
}

#formAlunoDataNascto {
    display: block;
  }

#formAlunoDataNascto1 {
  display: none;
}

@media (max-width: 740px) {

  #formAlunoDataNascto {
    display: block;
  }

  #formAlunoDataNascto1 {
    display: none;
  }
}

@media (max-width: 520px) {
  .vue-form-wizard .wizard-tab-content {
    min-height: 20px;
    padding: 20px 20px 10px;
  }

  .vue-form-wizard.md .wizard-navigation .wizard-progress-with-circle {
    position: relative;
    top: 26px;
    height: 4px;
  }

  .vue-form-wizard.md .wizard-icon-circle {
    max-width: 40px;
    max-height: 40px;
    font-size: 14px;
  }

  .vue-form-wizard .el-form-item__label {
    padding: 0;
    margin: 0;
  }

  .vue-form-wizard .stepTitle {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/cadastro.vue